var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 2H7.5C6.67192 2.00083 6.00083 2.67192 6 3.5V20C6.00083 20.8281 6.67192 21.4992 7.5 21.5H16.5C17.3279 21.4988 17.9988 20.8279 18 20V3.5C17.9992 2.67192 17.3281 2.00083 16.5 2ZM16.5 3.5V5H7.5V3.5H16.5ZM7.5 20V6.5H16.5V20H7.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/Mobile.acb9c1a85c0b4fb09371c1e3ebfc1e71.svg";
export { ForwardRef as ReactComponent };